export const gridTheme = {
  breakpoints: {
    // default bootstrap values
    xl: 1200,
    lg: 992,
    md: 768,
    sm: 576,
    xs: 575,
    xxs: 300,
  },
  container: {
    maxWidth: {
      // custom values (XD based)
      xl: 1162,
      lg: 650,
      md: 650,
      sm: 650,
      xs: 331,
    },
  },
};

const isSmallerThan = (width) => typeof window !== 'undefined' && window.innerWidth < width;
const isGreaterEqual = (width) => typeof window !== 'undefined' && window.innerWidth >= width;

export const isXxsMobile = () => isSmallerThan(gridTheme.breakpoints.xxs);
export const isXsMobile = () => isSmallerThan(gridTheme.breakpoints.xs);
export const isMobile = () => isSmallerThan(gridTheme.breakpoints.md);
export const isTablet = () =>
  isGreaterEqual(gridTheme.breakpoints.md) && isSmallerThan(gridTheme.breakpoints.xl);
